import { Button, Popup } from '@sam/components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Right } from 'shared';
import { useUser } from '../components/UserContext';
import { TimeWidget } from '../components/widgets/TimeWidget';
import { triggerDbImport } from '../utils/migration/Migration.axios';
import { isUserAllowedToDo } from '../utils/user/User.utils';
import { MailReportWidget } from '../components/widgets/MailReportWidget';

const Dashboard: React.FC = () => {
  const { axios, user } = useUser();
  const { t } = useTranslation();
  const [isOpen, toggleOpen] = useState<boolean>(false);

  /**
   * Util method to trigger an reload after the migration
   */
  const handleDBMigration = async (): Promise<void> => {
    if (!axios) return Promise.resolve();
    return triggerDbImport(axios).then((success) => {
      if (success) {
        window.location.reload();
      }
    });
  };
  return (
    <div className="dashboard-page">
      <Popup
        title={t('pages.dashboard.popupTitle')}
        isOpen={isOpen}
        buttons={[
          <Button onClick={() => toggleOpen(false)} value={t('general.buttons.cancel')} />,
          <Button onClick={handleDBMigration} value={t('general.buttons.migrateDB')} />,
        ]}
      >
        {t('pages.dashboard.migratePopup')}
      </Popup>

      <TimeWidget />
      <MailReportWidget />
      {JSON.parse(import.meta.env.VITE_SHOW_MIGRATION) &&
        isUserAllowedToDo(user.right, Right.ALL) && (
          <div className="widget-component__wrapper">
            <Button onClick={() => toggleOpen(true)} value={t('general.buttons.migrateDB')} />
          </div>
        )}
    </div>
  );
};

export default Dashboard;
